// extracted by mini-css-extract-plugin
export default {"address":"QLcm9","street":"DyusX","city":"uqyIZ","buttonWrapper":"UP4JB","linkPoiItemText":"bkYyF","linkPoiItem":"FZNEz"};